

































































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { Message } from '../../CommonUtils/fixed/Message';
import { ScreenMode } from '../../CommonUtils/fixed/ScreenMode';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
import { routingControlModule } from '@/store/modules/RoutingControl';
import { accepterUserRegistrationModule } from '../store/modules/AccepterUserRegistration';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class AccepterUserRegistration extends ApiAccessBase {
  private isRegist: boolean = false;

  private created() {
    this.screenTitle = 'ユーザ登録（パスワードの請求）';
    // モジュールに現在の画面を記録
    routingControlModule.registCurrent(this.$route.name);

    this.setVariablecolsState(['accepter_user_regist']);
    // APIアクセス
    this.apiAccess(UketsukeConstants.USER_REGIST_PATH_INIT + '/' + supervisingModule.GET_TENANT_ID, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );
  }

  /**
   * ユーザ登録
   */
  private userRegist() {
    // 入力チェック
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // 登録処理
    if (window.confirm(Message.I0003)) {
      this.apiAccess(
        UketsukeConstants.USER_REGIST_PATH_CREATE + '/' + supervisingModule.GET_TENANT_ID,
        Constants.API_METHOD_POST,
        true,
        false,
      ).then((result) => {
        if (result === Constants.API_RESULT_SUCCES) {
          this.isRegist = true;
        }
      });
    }
  }
  /**
   * 前画面に戻る
   */
  private returnPrevious() {
      // 前画面に戻る
      router.push('accepterTopMenu');
  }
}

